"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePrevScripts = exports.useScriptBasedWordTable = exports.useProjectWordTable = exports.useWordTable = void 0;
const models_hook_1 = require("app/models.hook");
const react_1 = require("react");
const models_1 = require("app/models");
const firestore_web_1 = require("comodel/firestore-web");
const ahocorasick_1 = require("utils/ahocorasick");
const standard_1 = require("react-hook-schema/standard");
function blobToText(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const text = reader.result;
            resolve(text);
        };
        reader.onerror = (error) => {
            reject(error);
        };
        reader.readAsText(blob);
    });
}
exports.useWordTable = (0, standard_1.createStorageCacheHook)((blob) => __awaiter(void 0, void 0, void 0, function* () {
    const startTime = Date.now();
    const text = yield blobToText(blob);
    const wordTable = JSON.parse(text);
    const words = wordTable.text || [];
    const wordReverse = Object.fromEntries(words.map((w, index) => [w, index]));
    const translations = wordTable.translations || {};
    const scriptId = wordTable.scriptId;
    const ah = new ahocorasick_1.AhoCorasick(words);
    const benchmarkTime = Date.now() - startTime;
    console.log("wordTable loaded in", benchmarkTime, "ms");
    return {
        search: (search, langId) => {
            const results = ah.search(search);
            const foundWords = new Set(results.map((r) => r[1]).flat());
            const foundIndex = Array.from(foundWords).map((r) => wordReverse[r]);
            return foundIndex.map((index) => {
                var _a;
                return {
                    id: scriptId[index],
                    text: words[index],
                    translation: (_a = translations[langId]) === null || _a === void 0 ? void 0 : _a[index],
                    isWord: true,
                };
            });
        },
        ah,
        words,
        translations,
        scriptIds: scriptId,
    };
}));
const useProjectWordTable = (projectId) => {
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const { value: wordTable } = (0, exports.useWordTable)(projectData.wordList) || {};
    const search = wordTable === null || wordTable === void 0 ? void 0 : wordTable.search;
    return search;
};
exports.useProjectWordTable = useProjectWordTable;
const useScriptBasedWordTable = (projectId, _unused) => {
    const [wordTable, setWordTable] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId }, { filter: { shouldIncludedIntoSegmentLevelWordTable: true } });
            const records = yield accessor.get();
            const filtered = records === null || records === void 0 ? void 0 : records.filter((r) => !!r.text && !!r.scriptId);
            const words = (_a = filtered === null || filtered === void 0 ? void 0 : filtered.map((r) => { var _a; return (_a = r.text) !== null && _a !== void 0 ? _a : ""; })) !== null && _a !== void 0 ? _a : [];
            const languages = [
                ...((_b = filtered === null || filtered === void 0 ? void 0 : filtered.reduce((prev, cur) => {
                    var _a;
                    const p = new Set(prev);
                    Object.keys((_a = cur.translations) !== null && _a !== void 0 ? _a : {}).forEach((l) => p.add(l));
                    return p;
                }, new Set())) !== null && _b !== void 0 ? _b : []),
            ];
            const translations = {};
            languages.forEach((language) => {
                var _a;
                translations[language] =
                    (_a = filtered === null || filtered === void 0 ? void 0 : filtered.map((r) => { var _a, _b; return (_b = (_a = r.translations) === null || _a === void 0 ? void 0 : _a[language]) !== null && _b !== void 0 ? _b : ""; })) !== null && _a !== void 0 ? _a : [];
            });
            const scriptId = (_c = filtered === null || filtered === void 0 ? void 0 : filtered.map((r) => { var _a; return (_a = r.scriptId) !== null && _a !== void 0 ? _a : ""; })) !== null && _c !== void 0 ? _c : [];
            const wordReverse = Object.fromEntries(words.map((w, index) => [w, index]));
            const ah = new ahocorasick_1.AhoCorasick(words);
            setWordTable({ words, translations, scriptId, wordReverse, ah });
        }))();
    }, [projectId]);
    return (0, react_1.useMemo)(() => {
        if (!wordTable)
            return null;
        const { ah, translations, scriptId, wordReverse, words } = wordTable;
        return (search, langId) => {
            const results = ah.search(search);
            const foundWords = new Set(results.map((r) => r[1]).flat());
            const foundIndex = Array.from(foundWords).map((r) => wordReverse[r]);
            return foundIndex.map((index) => {
                var _a;
                return {
                    id: scriptId[index],
                    text: words[index],
                    translation: (_a = translations[langId]) === null || _a === void 0 ? void 0 : _a[index],
                    isWord: true,
                };
            });
        };
    }, [wordTable]);
};
exports.useScriptBasedWordTable = useScriptBasedWordTable;
const usePrevScripts = (projectId, segmentId, langId, number = 3) => {
    const [scripts, setScripts] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const accessor = (0, firestore_web_1.queryAccessor)(models_1.scriptDefinition, { projectId, segmentId }, {
                filter: { segmentId },
            });
            const res = yield accessor.get();
            setScripts(res !== null && res !== void 0 ? res : []);
        }))();
    }, [projectId, segmentId]);
    return (0, react_1.useMemo)(() => {
        if (!scripts.length)
            return null;
        return (currentScriptId) => () => {
            if (!currentScriptId)
                return [];
            const currentScriptIdIndex = scripts.findIndex((item) => item.scriptId === currentScriptId);
            const filtered = scripts
                .slice(0, currentScriptIdIndex)
                .filter((item) => { var _a; return !!((_a = item.translations) === null || _a === void 0 ? void 0 : _a[langId]); })
                .filter((item) => !!item.text)
                .filter((_, i, arr) => i >= arr.length - number)
                .map((item) => {
                var _a;
                return {
                    id: item.scriptId,
                    // ensured
                    text: item.text,
                    // ensured
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
                    translation: (_a = item.translations) === null || _a === void 0 ? void 0 : _a[langId],
                    isWord: true,
                };
            });
            return filtered;
        };
    }, [scripts]);
};
exports.usePrevScripts = usePrevScripts;
